import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'summary-reports'
const verb = 'get'

export default class OspreyGetAudiences extends BaseAction {
    constructor(dataKey, onError) {
        const id = '5875a971-3d27-b33d-7f4c-6c9fce0972b5'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true

        this.onError = onError
    }

    getAudiences(params) {
        const { programId, ...param } = params

        this.path = `/${resource}/${programId}/audiences`
        this.params = {
            ...param
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/summary-reports/get-audiences.js